import {
  House, Megaphone, MagicWand, Package, Eye, ListChecks,
  ClockCounterClockwise, ChartLineUp, Sparkle, PlugsConnected, GearSix,
} from "@phosphor-icons/react";

// Promotion Center sitemap (RFC-0004 §2). `soon` items are visible but disabled
// until their phase ships — no dead links, always usable.
export const PROMO_NAV = [
  { to: "/promotions", key: "home", labelKey: "promo.nav.home", Icon: House, end: true },
  { to: "/promotions/campaigns", key: "campaigns", labelKey: "promo.nav.campaigns", Icon: Megaphone },
  { to: "/promotions/new", key: "new", labelKey: "promo.nav.new", Icon: MagicWand },
  { to: "/promotions/catalog", key: "catalog", labelKey: "promo.nav.catalog", Icon: Package, section: "operations" },
  { to: "/promotions/preview", key: "preview", labelKey: "promo.nav.preview", Icon: Eye },
  { to: "/promotions/queue", key: "queue", labelKey: "promo.nav.queue", Icon: ListChecks },
  { to: "/promotions/timeline", key: "timeline", labelKey: "promo.nav.timeline", Icon: ClockCounterClockwise },
  { to: "/promotions/performance", key: "performance", labelKey: "promo.nav.performance", Icon: ChartLineUp, section: "analytics" },
  { to: "/promotions/templates", key: "templates", labelKey: "promo.nav.templates", Icon: Sparkle },
  { to: "/promotions/connections", key: "connections", labelKey: "promo.nav.connections", Icon: PlugsConnected, section: "administration" },
  { to: "/promotions/settings", key: "settings", labelKey: "promo.nav.settings", Icon: GearSix, section: "administration" },
];

